import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getOrders = async (selectedDomain: string, filters: FilterProps[]): Promise<AppFetchResponse> => {
    const { from, to } = filters.find(filter => filter.filterKey === 'days')!;
    const clientFilter = filters.find(filter => filter.filterKey === 'clientId')!;
    const clientParam = clientFilter?.value ? `&clientId=${clientFilter.value}` : '';
    const checkoutFilter = filters.find(filter => filter.filterKey === 'checkoutId')!;
    const checkoutParam = checkoutFilter?.value ? `&checkoutId=${checkoutFilter.value}` : '';
    const orderFilter = filters.find(filter => filter.filterKey === 'orderId')!;
    const orderParam = orderFilter?.value ? `&orderId=${orderFilter.value}` : '';

    return appFetch({
        endpoint: `orders-log?domain=${selectedDomain}&from=${from}&to=${to}${clientParam}${orderParam}${checkoutParam}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}